import { db, auth, FieldValue, functions } from '../firebaseInit'
import { FbSecondary } from '../firebaseInitCreateUser'

export default {
  state: {
    users: [],
    inactiveUsers: [],
    roles: null,
    onProfile: false
  },
  mutations: {
    getInactiveUsers (state, payload) {
      state.inactiveUsers = payload
    },
    getRoles (state, payload) {
      state.roles = payload
    },
    editUser (state, payload) {
      state.users.splice(payload.index, 1)
      state.users.push(payload.newState)
    },
    getUsers (state, payload) {
      state.users = payload
    },
    createUser (state, payload) {
      state.users.push(payload)
    }
  },
  actions: {
    updateRole ({ commit }, payload) { // {doc: currentRole, role: role, type: create, update: update, value: value}
      if (payload.type === 'create' || payload.role === 'others' || payload.role === 'dropdowns') {
        db.collection('roles').doc(payload.doc).update({
          [payload.update]: payload.value
        })
      } else {
        let updateValues = { all: false, assigned: false, created: false, none: false }
        updateValues[payload.value] = true
        db.collection('roles').doc(payload.doc).update({
          [payload.update]: updateValues
        })
      }
    },
    getRoles ({ commit }, payload) {
      db.collection('roles').doc(payload).get().then(roles => {
        commit('getRoles', roles.data())
      })
    },
    activateUser ({ commit, state, dispatch, getters }, payload) {
      let updateUsers = {uid: payload.id, updateInfo: {disabled: false}}
      var getUser = functions.httpsCallable('getUserData')
      getUser(updateUsers).then((result) => {
        if (result.data === 'Success!') {
          db.collection('users').doc(payload.id).update({
            deleted: false,
            active: true
          })
          .then(() => {
            const logData = { timestamp: new Date(), collection: 'users', type: 're-activate', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' re-activated the user ' + payload.first_name + ' ' + payload.last_name, icon: 'person' }
            dispatch('commitLog', logData)
          })
        }
      })
    },
    deleteUser ({ commit, state, dispatch, getters }, payload) {
      let updateUsers = {uid: payload.id, updateInfo: {disabled: true}}
      var getUser = functions.httpsCallable('getUserData')
      getUser(updateUsers).then((result) => {
        if (result.data === 'Success!') {
          db.collection('users').doc(payload.id).update({
            active: false
          })
          .then(() => { // Remove User From All Active Projects
            db.collection('projects').where('active', '==', true).where('assigned_to', 'array-contains', payload.id).get().then(projects => {
              projects.forEach(project => {
                db.collection('projects').doc(project.id).update({assigned_to: FieldValue.arrayRemove(payload.id)})
              })
            })
          })
            .then(() => {
              const logData = { timestamp: new Date(), collection: 'users', type: 'delete', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' deleted the user ' + payload.first_name + ' ' + payload.last_name, icon: 'person' }
              dispatch('commitLog', logData)
            })
        }
      })
    },
    editUser ({ commit, state, dispatch, getters }, payload) {
      if (payload.newState.email !== payload.previousState.email) {
        var user = auth.currentUser
        user.updateEmail(payload.newState.email).then(() => {
        }).catch(error => {
          console.log('An Error Occurred While Editing: ', error)
        })
      }
      db.collection('users').doc(payload.previousState.id).update(payload.newState).then(() => {
        console.log('Write to Database Successful!')
      })
        .catch(error => console.log('Error writing to database! Error: ', error))
      if (payload.newState.id === getters.user.id) {
        commit('setUser', payload.newState)
      }
      const index = state.users.findIndex(i => i.email === payload.previousState.email)
      commit('editUser', { ...payload, index: index })
      const logData = { timestamp: new Date(), collection: 'users', type: 'edit', user_id: getters.user.id, record_id: payload.previousState.id, changed_from: payload.previousState, changed_to: payload.newState, message: getters.user.first_name + ' made changes to the user ' + payload.newState.first_name + ' ' + payload.newState.last_name, icon: 'person' }
      dispatch('commitLog', logData)
    },
    getUsers ({ commit, state }) {
      state.users = []
      db.collection('users').onSnapshot(querySnapshot => {
        let activeUsers = []
        let inactiveUsers = []
        querySnapshot.forEach(doc => {
          if (doc.data().active === true) {
            let usersList = doc.data()
            usersList = { ...usersList, id: doc.id }
            activeUsers.push(usersList)
          } else {
            let usersList = doc.data()
            usersList = { ...usersList, id: doc.id }
            inactiveUsers.push(usersList)
          }
        })
        commit('getUsers', activeUsers)
        commit('getInactiveUsers', inactiveUsers)
        commit('setLoading', false)
      })
    },
    // getInactiveUsers ({ commit, state }) {
    //   state.inactiveUsers = []
    //   db.collection('users').where('active', '==', false).get().then(querySnapshot => {
    //     querySnapshot.forEach(doc => {
    //       let usersList = doc.data()
    //       usersList = { ...usersList, id: doc.id }
    //       commit('getInactiveUsers', usersList)
    //     })
    //   })
    //     .then(() => {
    //       commit('setLoading', false)
    //     })
    // },
    createUser ({ commit, state, getters, dispatch }, payload) {
      // Secondary Firebase Config: Allows Creation WITHOUT Auto-Login
      // Add User to Firbase Authentication
      FbSecondary.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          const { id, password, ...withoutFirst } = payload
          const newUser = { ...withoutFirst, id: user.user.uid, created_by: getters.user.id, timestamp: new Date(), active: true, deleted: false }
          // Add User to Database
          db.collection('users').doc(user.user.uid).set(newUser)
            .then(function (docRef) {
              const logData = { timestamp: new Date(), collection: 'users', type: 'created', user_id: getters.user.id, record_id: user.user.uid, message: getters.user.first_name + ' created a new user' + ': ' + payload.first_name + ' ' + payload.last_name, icon: 'assignment_ind' }
              dispatch('commitLog', logData)
              commit('createUser', payload)
              // FbSecondary.auth().signOut()
              // FbSecondary.auth().delete()
            })
            .catch(function (error) {
              console.error('Error adding user: ', error)
              this.$store.dispatch('setError', { timestamp: new Date(), collection: 'users', type: 'create', user_id: getters.user.id, route: '/users', error: error })
              commit('setError', error.message)
              // FbSecondary.auth().signOut()
              // FbSecondary.auth().delete()
            })
        })
        .catch(error => {
          console.log('Error creating User: ', error)
          this.$store.dispatch('setError', { timestamp: new Date(), collection: 'FirebaseAuthentication', type: 'create', user_id: getters.user.id, route: '/users', error: error })
          commit('setError', error.message)
          FbSecondary.auth().signOut()
          FbSecondary.auth().delete()
        })
    }
  },
  getters: {
    roles (state) {
      return state.roles
    },
    inactiveUsers (state) {
      return state.inactiveUsers
    },
    userList (state) {
      return state.users
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/admin.js